import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import searches from '../../../../../../utils/routing/searches'
import { capitalize } from '../../../../../../utils/string'

export default class Search360Link extends Component {
  static propTypes = {
    rec: PropTypes.string,
    recType: PropTypes.oneOf(['career', 'education']),
  }
  render() {
    const { rec, recType } = this.props
    return (
      <Link
        to={searches.buildUrlForSearchType({
          searchType: recType,
          searchParams: {
            search_query: rec,
          },
        })}
        className={`tag-suggest-${recType}`}
      >
        <i className="fal fa-search" />
        &nbsp;
        {capitalize(rec)}
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Career/components/Search360Link.js